import React, { useEffect, useState } from "react";
// import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import InputAdornment from "@mui/material/InputAdornment";
import "./Getquotations.css";
import FrameImage from "../assets/img/images/images/Frame.png"; // Import the image
import AddIcon from "@mui/icons-material/Add";
import Header from "../components/Header"; //header
import Footer from "../components/Footer"; //footer
import AOS from "aos";
import "aos/dist/aos.css";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import plusicon from "../assets/img/product_img/plusicon.png";
import { Link } from "react-router-dom";
import Emailjs from "emailjs-com";
import AutoDeleteRounded from "@mui/icons-material/AutoDeleteRounded";
import { Helmet } from "react-helmet-async";
import WhatsappButton from "../components/WhatsappButton";

const Form = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  const theme = createTheme({
    components: {
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            backgroundColor: "#00a6d6",
            color: "#fff",
            fontWeight: "bold",
          },
          deleteIcon: {
            color: "#fff",
          },
        },
      },
    },
  });

  const [selectedItems, setSelectedItems] = useState([]);
  const [mobilenumber, setMobilenumber] = useState("");

  const [unselectedItems, setUnselectedItems] = useState([
    "Trampoline",
    "Performance Trampoline",
    "Foam Pit/ Balance",
    "Dodge Ball",
    "Wipe Out",
    "Air Bag",
    "Softplay",
    "Toddler",
    "Roleplay",
    "Car track",
    "Zipline",
    "Slide",
    "Sand Area",
    "Ball Pool",
    "Doughnut Slide",
    "Climbing Wall",
    "Ninja Park",
    "Interactive Games",
    "Entrance Software",
  ]);
  const handleDelete = (game) => {
    setSelectedItems((prev) => prev.filter((g) => g !== game));
    setUnselectedItems((prev) => [...prev, game]);
  };

  const handleAdd = (game) => {
    setUnselectedItems((prev) => prev.filter((g) => g !== game));
    setSelectedItems((prev) => [...prev, game]);
  };

  const handleOnChange = (value) => {
    console.log(value);
  };
  const handleSave = () => {
    alert("message is submited");
  };

  const [item, setItem] = useState({
    firstname: "",
    lastname: "",
    email: "",
    countryCode: "+1",
    mobilenumber: "",
    locationsize: "",
    games: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("changing", name, value); //debugging log

    setItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handleCheckBoxChange = (game) => {
    setItem((prev) => ({
      ...prev,
      games: prev.games.includes(game)
        ? prev.games.filter((g) => g !== game)
        : [...prev.games, game],
    }));
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  // Validation
  if (!item.firstname.trim()) {
    alert("Please enter your first name.");
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!item.email.trim() || !emailRegex.test(item.email)) {
    alert("Please enter a valid email address.");
    return;
  }

  // New mobile number validation (only check for alphabets)
  const alphaRegex = /[a-zA-Z]/;
  if (!item.mobilenumber.trim()) {
    alert("Please enter your mobile number.");
    return;
  }
  if (alphaRegex.test(item.mobilenumber)) {
    alert("Mobile number should not contain alphabet characters.");
    return;
  }
    if (!item.notARobot) {
    alert("Please confirm you are not a robot.");
    return;
  }

  const templateParams = {
    firstname: item.firstname,
    lastname: item.lastname,
    email: item.email,
    countryCode: item.countryCode,
    mobilenumber: item.mobilenumber,
    locationsize: item.locationsize,
    games: selectedItems.join(","),
  };
  console.log("------------------------------------------------->>>>>", templateParams);

  Emailjs.send(
    "service_3f6cyw8",
    "template_xrsw49z",
    templateParams,
    "u3W-si69qTqJUjdDm"
  )
    .then((response) => {
      console.log("SUCCESS!", response.status, response.text);
      alert("Email sent successfully!");
      window.location.reload();
    })
    .catch((err) => {
      console.error("FAILED...", err);
      alert("There was an error submitting the form.");
      window.location.reload();
    });
};

  return (
    <div>
      <Helmet>
        <meta
          name="playground equipment manufacturers"
          content="Discover GEM, the highest quality trampoline for soft play and fun. 
Perfect for kids and families seeking excitement and safety in one 
amazing experience."
        />
      </Helmet>
      <Header />
      <div className="container">
        <div className="div-box">
          <div
            className="left-section"
            data-aos="zoom-in-right"
            data-aos-duration="2500"
          >
            <h2>
              Have A Project In <br /> Mind? Let’s Talk.
            </h2>
            {/* <p>
            Looking for tailored solutions to meet your business needs? Request
            a quote now and let us help you find the perfect fit.
          </p> */}
          </div>
            <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
          <Link
            to="/getquotations"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div className="icon-container">
              <img
                src={plusicon}
                alt="plusicon"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>
          <div
            className="card-box"
            data-aos="zoom-in-right"
            data-aos-duration="2500"
          >
            <div className="contact-address">
              <span className="location-icon">
                <FaLocationDot />
              </span>{" "}
              <p className="text">
                {" "}
                Sahab, Street No. 60
                <br />
                Amman, Jordan.
              </p>
            </div>
            <div className="contact-no">
              <span className="react-icon">
                <FaPhoneAlt />
              </span>
              <p
                className="number"
                onClick={() =>
                  window.open(`https://wa.me/962791008716`, "_blank")
                }
              >
                {" "}
                +962791008716
              </p>
            </div>
            <div className="contact-mail">
              <span className="mail-icon">
                <IoMdMail />
              </span>
              <p className="mail"> info@gemplay.com.jo</p>
            </div>
          </div>
        </div>
        <div
          className="right-section"
          data-aos="zoom-in-left"
          data-aos-duration="2500"
        >
          <div className="enquiry-box">
            <h2>Enquire Now</h2>
            <form onSubmit={handleSave}>
              <div className="input-row1">
                <TextField
                  required
                  id="outlined-required"
                  label="First name"
                  name="firstname" //Added missing 'name' attribute
                  value={item.firstname} //Removed '?.' as 'item' is always defined
                  onChange={handleChange}
                />
                <TextField
                  required
                  id="outlined-required"
                  label="Last Name"
                  name="lastname"
                  value={item.lastname}
                  onChange={handleChange}
                />
              </div>
              <div className="input-row2">
                <TextField
                  required
                  id="outlined-required"
                  label="email"
                  name="email"
                  value={item.email}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                />
                {/* <TextField
                  id="outlined-number"
                  label="Mobile Number"
                  name="mobilenumber"
                  value={item.mobilenumber}
                  onChange={handleChange}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <PhoneInput
                            country={"us"}
                            enableSearch={true}
                            onChange={handleOnChange}
                            containerStyle={{
                              border: "none",
                              width: "100%",
                            }}
                            buttonStyle={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            inputStyle={{
                              border: "none",
                              boxShadow: "none",
                              width: "auto", // Ensures it does not exceed the div width
                            }}
                            dropdownStyle={{
                              zIndex: 1000,
                            }}
                          />
                        </div>
                      </InputAdornment>
                    ),
                  }}
                /> */}
                {/* <TextField
                  id="outlined-number"
                  label="Mobile Number"
                  name="mobilenumber"
                  value={item.mobilenumber} // This should be controlled properly
                  onChange={handleChange}
                  style={{ width: "50%" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
            
                        <PhoneInput
                          country={"us"}
                          enableSearch={true}
                          value={item.mobilenumber} // Controlled component
                          onChange={(value) =>
                            setItem((prev) => ({
                              ...prev,
                              mobilenumber: value,
                            }))
                          } // Updates mobilenumber in state
                          containerStyle={{ border: "none"}}
                          buttonStyle={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          inputStyle={{
                            border: "none",
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            width: "auto",
                            // overflowX: "hidden",
                          }}
                          dropdownStyle={{ zIndex: 1000 }}
                        />
                        
                      </InputAdornment>
                    ),
                  }}
                />  */}

                <div
                  className="input-row2"
                  style={{ display: "flex", gap: "1%" }}
                >
                  {/* Country Code Picker */}
                  <div style={{ display: "flex" }}>
                    <div>
                      <PhoneInput
                        country={"us"}
                        enableSearch={true}
                        value={item.countryCode}
                        onChange={(_, countryData) =>
                          setItem((prev) => ({
                            ...prev,
                            countryCode: `+${countryData.dialCode}`,
                          }))
                        }
                        inputStyle={{
                          width: "100px",
                          marginLeft: "10px",
                          height: "55px",
                        }}
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </div>

                    {/* Mobile Number Input */}
                    <TextField
                      id="outlined-number"
                      label="Mobile Number"
                      name="mobilenumber"
                      value={item.mobilenumber}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Location size
                </FormLabel>
                <RadioGroup
                  row
                  name="locationsize"
                  value={item.locationsize}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="50-200 sq mtr"
                    control={<Radio />}
                    label="50-200 sq mtr"
                  />
                  <FormControlLabel
                    value="201-500 sq mtr"
                    control={<Radio />}
                    label="201-500 sq mtr"
                  />
                  <FormControlLabel
                    value="501-1000 sq mtr"
                    control={<Radio />}
                    label="501-1000 sq mtr"
                  />
                  <FormControlLabel
                    value="1001 and above sq mtr"
                    control={<Radio />}
                    label="1001 and above sq mtr"
                  />
                </RadioGroup>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Games
                </FormLabel>
              </FormControl>
              <ThemeProvider theme={theme}>
                <Stack direction="row" spacing={1} className="chip-container">
                  {selectedItems.map((item) => (
                    <Chip
                      key={item}
                      label={item}
                      onDelete={() => handleDelete(item)}
                      onClick={() => handleCheckBoxChange(item)} //This should toggle games in state
                    />
                  ))}
                </Stack>

                <Stack
                  direction="row"
                  spacing={1}
                  marginTop={2}
                  className="chip-container"
                >
                  {/* Render unselected items as buttons with a "+" icon */}
                  {unselectedItems.map((item) => (
                    <Chip
                      key={item}
                      onClick={() => handleAdd(item)}
                      style={{
                        backgroundColor: "#f0f0f0",
                        color: "#000",
                        border: "1px solid #ccc",
                        cursor: "pointer",
                      }}
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {item}
                          <AddIcon
                            fontSize="small"
                            style={{ marginLeft: "5px" }}
                          />
                        </div>
                      }
                    />
                  ))}
                </Stack>
              </ThemeProvider>
              <div className="checkbox-row">
                <input
                  type="checkbox"
                  id="not-a-robot"
                  checked={item.notARobot || false} // Ensuring controlled checkbox
                  onChange={(e) =>
                    setItem((prev) => ({
                      ...prev,
                      notARobot: e.target.checked,
                    }))
                  }
                  required
                />
                <label htmlFor="not-a-robot">I’m not a robot</label>
                <img src={FrameImage} alt="Recaptcha Icon" />
              </div>
              <button
                type="submit"
                className="submit-button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Form;
